import {
  LucideGitCompareArrows,
  LucideMap,
  LucideMapPinHouse,
  LucideMapPinned,
  LucideScanSearch,
} from 'lucide-react'
import { useMemo } from 'react'
import { aOrganization, aUser, useAtomValue } from '~/atoms'
import type { Listing } from '~/models'
import { createSignedCRSLink, getCRSListingLink } from '~/utils/crs'

export function useCRSLink() {
  const user = useAtomValue(aUser)
  const organization = useAtomValue(aOrganization)

  const link = useMemo(() => {
    if (!user || !organization) return undefined

    return createSignedCRSLink({
      organization: organization.slug,
      user: user.tid,
    })
  }, [user?.tid, organization!.slug])

  return link
}

export function useCRSListingLink(listing: Listing) {
  const url = useCRSLink()

  return useMemo(() => {
    if (!url) return []

    const links = [
      {
        label: 'Property Report',
        icon: LucideMapPinned,
        url: getCRSListingLink({
          cmd: 'rpt',
          listing,
          url,
        }).href,
      },
      {
        label: 'Demographics',
        icon: LucideMapPinHouse,
        url: getCRSListingLink({
          cmd: 'dem',
          listing,
          url,
        }).href,
      },
      {
        label: 'Property Comparables',
        icon: LucideGitCompareArrows,
        url: getCRSListingLink({
          cmd: 'cmp',
          listing,
          url,
        }).href,
      },
      {
        label: 'Prospecting',
        icon: LucideScanSearch,
        url: getCRSListingLink({
          cmd: 'prospect',
          listing,
          url,
        }).href,
      },
      {
        label: 'Parcel Map',
        icon: LucideMap,
        url: getCRSListingLink({
          cmd: 'map',
          listing,
          url,
        }).href,
      },
    ]
    return links
  }, [url, listing])
}
